import React, { useState } from 'react';
import { Container, Row, Col, Tab, Card, Modal } from 'react-bootstrap';
import healthcareCards from '../../../data/healthcareCards';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import '../../../styles/_carousel.scss'


const responsive = {
  superLargeDesktop: { breakpoint: { max: 4000, min: 1200 }, items: 4 },
  desktop: { breakpoint: { max: 1200, min: 992 }, items: 3 },
  tablet: { breakpoint: { max: 992, min: 768 }, items: 2 },
  mobile: { breakpoint: { max: 768, min: 0 }, items: 1 },
};

const ClientsPage = () => {
  const [activeTab, setActiveTab] = useState('Healthcare');
  const [showModal, setShowModal] = useState(false);
  const [modalHeadline, setModalHeadline] = useState('');
  const [modalBodyContent, setModalBodyContent] = useState(null);
  const [modalLogoImage, setModalLogoImage] = useState(null);

  const handleImageClick = (headline, modalBody, logoImage) => {
    setModalHeadline(headline);
    setModalBodyContent(modalBody);
    setModalLogoImage(logoImage);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setModalHeadline('');
    setModalBodyContent(null);
    setModalLogoImage(null);
  };

  const categoryMap = {
    Auto: 'Auto',
    CPG: 'CPG',
    Healthcare: 'Healthcare',
    'CE & Tech': 'CETech',
    Specialty: 'Specialty',
  };

  const cards = {
    Healthcare: healthcareCards,
  };
  return (

    <section className="py-3">
      <Container>
        <Row>
          <Col>
            <h2 className="font-bold text-center mb-4">Our Healthcare Clients</h2>
            <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
              <Tab.Content>
                {Object.entries(categoryMap).map(([label, key]) => (
                  <Tab.Pane eventKey={label} key={label}>
                    {activeTab === label && (
                      <Carousel
                        responsive={responsive}
                        infinite
                        autoPlay={false}
                        transitionDuration={1000}
                        keyBoardControl
                        containerClass="carousel-container"
                        itemClass="px-2"
                        arrows
                      >
                        {cards[key].map(({ image, headline, icon, modalBody, logoImage }, i) => (
                          <div
                            key={i}
                            onClick={() => handleImageClick(headline, modalBody, logoImage)}

                            style={{ cursor: 'pointer' }}
                            className="text-decoration-none"
                          >
                            <Card className="bg-dark text-white h-100 img-radius position-relative card-tall">
                              <Card.Img variant="top" src={image} className="img-fluid img-radius card-img fixed-card-img fixed-card-img" loading="lazy" />
                              <div className="bg-black bg-opacity-25 card-gradient position-absolute top-0 start-0 w-100 h-100 img-radius"></div>
                              <Card.ImgOverlay className="d-flex flex-column justify-content-start text-start p-3">
                                <div className="d-flex align-items-center mb-2">
                                  <Card.Title className="font-bold fs-6 text-white mb-0 me-2 z-2">{label}</Card.Title>
                                  <i className={`bi ${icon} fs-5 text-white align-self-center z-2`}></i>
                                </div>
                                <div className="font-bold fs-4 text-white z-2">{headline}</div>
                              </Card.ImgOverlay>
                            </Card>
                          </div>
                        ))}
                      </Carousel>
                    )}
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>

      {/* Modal */}
      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        size="md"
        contentClassName="bg-black text-white position-relative text-sm img-radius"
      >
        <Modal.Header className="border-0 bg-white">
          <Modal.Title className="font-bold fs-4 text-white z-2 d-flex align-items-center gap-2">
            {modalLogoImage && (
              <img
                src={modalLogoImage}
                alt={modalHeadline}
              />
            )}
          </Modal.Title>
          <button
            type="button"
            onClick={handleClose}
            className="btn position-absolute top-0 end-0"
            style={{ fontSize: '3rem', color: 'red', background: 'none', border: 'none' }}
            aria-label="Close"
          >
            &times;
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                {modalBodyContent || "No content available"}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default ClientsPage;